export default __webpack_public_path__ + "static/media/avatarB4.b18ebe14.png";